import { render, staticRenderFns } from "./RequestPostList.vue?vue&type=template&id=6928444a&scoped=true&"
import script from "./RequestPostList.vue?vue&type=script&lang=js&"
export * from "./RequestPostList.vue?vue&type=script&lang=js&"
import style0 from "./RequestPostList.vue?vue&type=style&index=0&id=6928444a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6928444a",
  null
  
)

export default component.exports